// Shopify App Proxy is the only persistence endpoint. No personal data is kept in browser storage.
class RepairRegistration extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort=new AbortController();this.controllers=new Set();this.step=0;this.ready=false;this.media=[];
    this.strings=JSON.parse(this.querySelector('[data-repair-strings]').textContent);
    this.form=this.querySelector('[data-repair-form]');
    if (!this.form) return;
    this.steps=[...this.querySelectorAll('[data-step]')];
    this.endpoint=this.dataset.endpoint;
    if (!/^\/apps\/[a-z0-9_-]+$/i.test(this.endpoint)) {this.serviceMessage('unavailable');return;}
    const on=(el,event,handler)=>el?.addEventListener(event,handler,{signal:this.abort.signal});
    on(this.querySelector('[data-next]'),'click',()=>{if(this.validStep())this.showStep(this.step+1);});
    on(this.querySelector('[data-back]'),'click',()=>this.showStep(this.step-1));
    on(this.querySelector('[data-retry]'),'click',()=>this.bootstrap());
    on(this.querySelector('[data-new]'),'click',()=>this.reset());
    on(this.querySelector('[data-print]'),'click',()=>this.printCard());
    on(this.querySelector('[data-lookup-print]'),'click',()=>this.printCard(true));
    on(this.form,'change',()=>this.syncFields());
    on(this.form,'input',event=>{event.target.setCustomValidity?.('');event.target.removeAttribute('aria-invalid');});
    on(this.querySelector('[data-media-files]'),'change',event=>this.selectMedia(event.target));
    on(this.querySelector('[data-upload-retry]'),'click',()=>this.uploadPending());
    on(this.form,'submit',event=>{event.preventDefault();this.submit();});
    on(this.querySelector('[data-lookup]'),'submit',event=>{event.preventDefault();this.lookup();});
    on(this.querySelector('[data-lookup] button'),'click',event=>{event.preventDefault();this.lookup();});
    // De-duplicate identical fallback models without filtering out discontinued or out-of-stock robots.
    const seen=new Set();
    for (const option of [...this.form.elements.model.options]) {
      const title=option.value.trim().toLowerCase();
      const anthbot=title.match(/\banthbot\s+(genie\s+\d+[a-z]*|m\d+(?:\s*(?:pro|lidar|lite))?|n\d+|r\d+)\b/);
      const key=anthbot?'anthbot:'+anthbot[1].replace(/\s+/g,''):title;
      if(seen.has(key)) option.remove();else seen.add(key);
    }
    this.form.elements.purchaseDate.max=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Vilnius',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());
    this.syncFields();this.showStep(0,false);
    this.bootstrap();
    const caseParam=new URLSearchParams(location.search).get('case');
    if(/^KR-[A-F0-9]{20}$/.test(caseParam||'')){
      const lookup=this.querySelector('[data-lookup]');lookup.id='remonto-byla';
      lookup.querySelector('[name=case]').value=caseParam;this.lookup();
    }
  }
  disconnectedCallback() {
    this.abort?.abort();this.abort=null;
    for(const controller of this.controllers || [])controller.abort();
    for(const item of this.media||[])if(item.preview)URL.revokeObjectURL(item.preview);
  }
  t(key) {return this.strings[key] || this.strings.unavailable;}
  serviceMessage(key) {this.querySelector('[data-service-status]').textContent=this.t(key);}
  error(key) {
    const el=this.querySelector('[data-error]');el.textContent=key?this.t(key):'';el.hidden=!key;
  }
  printCard(fromLookup=false) {
    const success=this.querySelector('[data-success]'),lookup=this.querySelector('[data-lookup-result]');
    const card=!fromLookup&&success&&!success.hidden?success:lookup?.querySelector('dl')?lookup:null;
    if(!card||card.hidden)return;
    // Print a separate document containing only the confirmed case card. Theme,
    // navigation, chat widgets and the rest of the form never enter this document.
    this.printFrame?.remove();
    const frame=document.createElement('iframe');this.printFrame=frame;
    frame.title=this.t('print');frame.setAttribute('aria-hidden','true');
    Object.assign(frame.style,{position:'fixed',width:'1px',height:'1px',inset:'0',border:'0',opacity:'0',pointerEvents:'none'});
    const doc=document.implementation.createHTMLDocument();
    const charset=doc.createElement('meta');charset.setAttribute('charset','utf-8');doc.head.append(charset);
      doc.documentElement.lang=document.documentElement.lang||'lt';
      doc.title=this.t('case_number')+' '+(card.querySelector('[data-case-number]')?.textContent||card.dataset.caseNumber||'');
      const style=doc.createElement('style');
      style.textContent='@page{size:A4;margin:15mm}*{box-sizing:border-box}body{margin:0;background:#fff;color:#111;font:12pt/1.5 Arial,sans-serif}h2{font-size:20pt;margin:0 0 16px}.kr-repair__panel{border:0;padding:0;margin:0}.kr-repair__case{display:block;font-size:22pt;overflow-wrap:anywhere;margin:12px 0 24px}.kr-repair__review{display:grid;grid-template-columns:40% 60%;margin:0 0 24px}.kr-repair__review dt,.kr-repair__review dd{margin:0;padding:8px 0;border-bottom:1px solid #ddd;overflow-wrap:anywhere;white-space:pre-line;break-inside:avoid}.kr-repair__review dt{font-weight:bold;padding-right:16px}small{font-size:10pt}';
      doc.head.append(style);
      const copy=doc.importNode(card,true);copy.removeAttribute('hidden');
      if(card===lookup){const heading=doc.createElement('h2');heading.textContent=this.t('case_number');copy.prepend(heading);}
      copy.querySelectorAll('.kr-repair__actions,button,script').forEach(el=>el.remove());
      doc.body.append(copy);
    frame.addEventListener('load',()=>{
      const view=frame.contentWindow;
      view.addEventListener('afterprint',()=>{frame.remove();if(this.printFrame===frame)this.printFrame=null;},{once:true});
      // Some browsers do not fire afterprint when their preview is cancelled.
      setTimeout(()=>{if(this.printFrame===frame){frame.remove();this.printFrame=null;}},120000);
      view.focus();view.print();
    },{once:true});
    frame.srcdoc='<!doctype html>'+doc.documentElement.outerHTML;
    document.body.append(frame);
  }
  async api(path,options={}) {
    const controller=new AbortController();this.controllers.add(controller);
    const timer=setTimeout(()=>controller.abort(),25000);
    try {
      const direct=options.direct;const requestOptions={...options};delete requestOptions.direct;
      const proxyPath=path+(path.includes('?')?'&':'?')+'_kr='+Date.now();
      const response=await fetch(direct?.url||this.endpoint+proxyPath,{credentials:direct?'omit':'same-origin',mode:direct?'cors':'same-origin',cache:'no-store',...requestOptions,
        headers:{...requestOptions.headers,...(direct?{Authorization:'Bearer '+direct.token}:{})},signal:controller.signal});
      const type=response.headers.get('content-type') || '';
      this.dataset.transportStatus=response.status+':'+type;
      if(!type.includes('application/json')) {console.warn('Repair response',response.status,type);const error=new Error('unavailable');error.retryable=response.status>=500||response.ok;throw error;}
      const data=await response.json();
      if(!response.ok || data.error)throw Object.assign(new Error(({invalid_fields:'invalid_value',invalid_postal:'validation',payload_too_large:'invalid_value',acknowledgement_required:'required',authentication:'login_required',storage_unavailable:'unavailable'})[data.error] || data.error || 'unavailable'),{retryable:response.status>=500});
      return data;
    } finally {clearTimeout(timer);this.controllers.delete(controller);}
  }
  async bootstrap() {
    this.ready=false;this.querySelector('[data-submit]').disabled=true;
    if(this.dataset.enabled!=='true'){this.serviceMessage('not_enabled');return;}
    this.serviceMessage('loading');
    try {
      // A transport retry reuses the same server-issued id, preventing duplicate cases.
      if(!this.session) this.session=await this.retryApi('/bootstrap');
      this.dataset.sessionShape=Object.keys(this.session).join(',');
      if(!this.session.requestId || !this.session.csrf)throw new Error('unavailable');
      this.querySelector('[data-media-files]').disabled=!this.session.upload;
      this.ready=true;
      this.querySelector('[data-workspace]').hidden=false;
      this.querySelector('[data-service-status]').hidden=true;
      this.querySelector('[data-retry]').hidden=true;
      this.querySelector('[data-submit]').disabled=false;
    } catch(error) {
      this.dataset.connectionFailure=error.name+':'+error.message;
      this.serviceMessage(this.strings[error.message]?error.message:'unavailable');
      this.querySelector('[data-service-status]').hidden=false;
      this.querySelector('[data-retry]').hidden=false;
    }
  }
  syncFields() {
    const other=this.form.elements.model.value==='__other__';
    this.querySelector('[data-custom-model]').hidden=!other;
    this.form.elements.custom_model.disabled=!other;
    const returning=this.form.elements.returnMethod.value==='courier';
    const pickup=this.form.elements.delivery.value==='courier_request';
    const same=returning && pickup && this.form.elements.sameAddress.checked;
    for(const [name,active] of [['returnAddress',returning],['pickupAddress',pickup && !same]]) {
      const fieldset=this.querySelector(`[data-address="${name}"]`);
      fieldset.hidden=!active;fieldset.disabled=!active;
    }
    this.querySelector('[data-same-label]').hidden=!(returning && pickup);
  }
  mediaError(key) {const el=this.querySelector('[data-upload-error]');el.textContent=key?this.t(key):'';el.hidden=!key;}
  selectMedia(input) {
    const limit=this.session?.upload;if(!limit)return;
    this.mediaError(null);
    for(const file of input.files) {
      if(this.media.length>=limit.count||file.size>limit.fileBytes||this.media.reduce((n,f)=>n+f.file.size,0)+file.size>limit.totalBytes){this.mediaError('upload_limit');continue;}
      if(!/\.(jpe?g|png|webp|heic|heif|avif|mp4|mov|webm)$/i.test(file.name)){this.mediaError('upload_type');continue;}
      const id=crypto.randomUUID();this.media.push({id,file,state:'pending',progress:0,preview:/^image\/(jpeg|png|webp|avif)$/.test(file.type)?URL.createObjectURL(file):null});
    }
    input.value='';this.renderMedia();this.uploadPending();
  }
  renderMedia() {
    const list=this.querySelector('[data-media-list]');list.replaceChildren();
    for(const item of this.media) {
      const li=document.createElement('li');li.className='kr-repair__upload-item';
      if(item.preview){const img=document.createElement('img');img.src=item.preview;img.alt='';img.width=72;img.height=72;li.append(img);}
      const info=document.createElement('div'),name=document.createElement('strong'),status=document.createElement('span');name.textContent=item.file.name;
      status.textContent=`${(item.file.size/1024/1024).toFixed(1)} MB · ${this.t('upload_'+item.state)}`;info.append(name,status);
      if(item.state==='uploading'){const progress=document.createElement('progress');progress.max=100;progress.value=item.progress;progress.setAttribute('aria-label',this.t('upload_uploading'));info.append(progress);}
      const remove=document.createElement('button');remove.type='button';remove.textContent=this.t('upload_remove');remove.disabled=this.uploading||this.busy;
      remove.addEventListener('click',()=>this.removeMedia(item));li.append(info,remove);list.append(li);
    }
    this.querySelector('[data-upload-retry]').hidden=!this.media.some(f=>f.state==='error');
  }
  async removeMedia(item) {
    if(this.busy||this.uploading)return;
    try {
      if(item.state!=='pending') {const c=this.session.upload,r=await fetch(c.url,{method:'DELETE',mode:'cors',credentials:'omit',headers:{Authorization:'Bearer '+c.token,'X-Upload-ID':item.id}});if(!r.ok)throw new Error('upload_failed');}
      this.media=this.media.filter(f=>f!==item);if(item.preview)URL.revokeObjectURL(item.preview);this.renderMedia();this.mediaError(null);
    }catch{this.mediaError('upload_failed');}
  }
  uploadFile(item) {
    const config=this.session.upload;
    if(config.url!=='https://service.ner.lt/uploads')return Promise.reject(new Error('upload_failed'));
    return new Promise((resolve,reject)=>{
      const xhr=new XMLHttpRequest();this.controllers.add(xhr);xhr.open('POST',config.url);xhr.timeout=180000;
      xhr.setRequestHeader('Authorization','Bearer '+config.token);xhr.setRequestHeader('X-Upload-ID',item.id);
      xhr.setRequestHeader('X-File-Name',encodeURIComponent(item.file.name));xhr.setRequestHeader('Content-Type','application/octet-stream');
      xhr.upload.onprogress=event=>{if(event.lengthComputable){item.progress=Math.round(event.loaded/event.total*100);this.renderMedia();}};
      const fail=key=>{this.controllers.delete(xhr);reject(new Error(key));};
      xhr.onerror=()=>fail('upload_failed');xhr.ontimeout=()=>fail('upload_failed');xhr.onabort=()=>fail('upload_failed');
      xhr.onload=()=>{this.controllers.delete(xhr);let data;try{data=JSON.parse(xhr.responseText);}catch{return fail('upload_failed');}if(xhr.status!==200||data.error)return fail(['upload_limit','upload_type','upload_closed','upload_storage'].includes(data.error)?data.error:'upload_failed');if(data.id!==item.id)return fail('upload_failed');resolve(data);};
      xhr.send(item.file);
    });
  }
  async uploadPending() {
    if(this.uploading||!this.session?.upload)return;
    this.uploading=true;this.mediaError(null);this.querySelector('[data-submit]').disabled=true;
    for(const item of this.media.filter(f=>f.state==='pending'||f.state==='error')) {
      item.state='uploading';this.renderMedia();
      try {item.saved=await this.uploadFile(item);item.state='done';}
      catch(error){item.state='error';this.mediaError(error.message);}
      this.renderMedia();
    }
    this.uploading=false;this.renderMedia();this.querySelector('[data-submit]').disabled=!this.ready||this.busy;
    // Files added while a previous upload was running still enter the queue.
    if(this.media.some(f=>f.state==='pending'))this.uploadPending();
    if(this.step===3)this.review();
  }
  validStep(focus=true) {
    let invalid;
    for(const input of this.steps[this.step].querySelectorAll('input,select,textarea')) {
      if(input.disabled || input.closest('fieldset[disabled]'))continue;
      input.setCustomValidity('');
      const value=input.value.trim(),min={custom_model:2,serial:3,name:2,'returnAddress.name':2,'returnAddress.street':3,'returnAddress.city':2,'returnAddress.postal':3}[input.name];
      if(input.required&&input.type!=='checkbox'&&!value||min&&value.length<min)input.setCustomValidity(this.t('invalid_value'));
      if(input.name==='phone'&&(!/^\+?[\d\s().-]+$/.test(value)||value.replace(/\D/g,'').length<7||value.length>35))input.setCustomValidity(this.t('invalid_value'));
      if(input.name==='email'&&!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))input.setCustomValidity(this.t('invalid_email'));
      if(input.hasAttribute('data-postal')) {
        const country=this.form.elements[input.name.split('.')[0]+'.country'].value;
        if(country==='LT' && !/^(LT[- ]?)?\d{5}$/i.test(input.value.trim()))input.setCustomValidity(this.t('validation'));
      }
      if(input.name==='description' && input.value.trim().length<20) input.setCustomValidity(this.t('description_help'));
      if(!input.checkValidity()) {input.setAttribute('aria-invalid','true');invalid ||= input;}
      else input.removeAttribute('aria-invalid');
    }
    if(invalid){this.error(invalid.validity.valueMissing?'required':invalid.type==='email'?'invalid_email':'invalid_value');const label=this.form.querySelector('label[for="'+invalid.id+'"]');if(label)this.querySelector('[data-error]').textContent+=' '+label.textContent.trim();if(focus){invalid.setCustomValidity(this.querySelector('[data-error]').textContent);invalid.focus();invalid.reportValidity();}return false;}
    this.error(null);return true;
  }
  showStep(index,focus=true) {
    this.step=Math.max(0,Math.min(3,index));
    this.steps.forEach((s,i)=>s.hidden=i!==this.step);
    this.querySelectorAll('[data-progress]').forEach((li,i)=>{if(i===this.step)li.setAttribute('aria-current','step');else li.removeAttribute('aria-current');});
    this.querySelector('[data-back]').hidden=this.step===0;
    this.querySelector('[data-next]').hidden=this.step===3;
    this.querySelector('[data-submit]').hidden=this.step!==3;
    this.error(null);
    if(this.step===3)this.review();
    if(focus)this.steps[this.step].querySelector('h2').focus();
  }
  payload() {
    const data=Object.fromEntries(new FormData(this.form));
    if(data.model==='__other__')data.model=data.custom_model;
    for(const prefix of ['returnAddress','pickupAddress']) {
      data[prefix]=Object.fromEntries(['name','street','city','postal','country'].map(key=>[key,data[`${prefix}.${key}`] || '']));
      for(const key of Object.keys(data))if(key.startsWith(prefix+'.'))delete data[key];
    }
    if(data.delivery==='courier_request' && data.returnMethod==='courier' && data.sameAddress==='on')data.pickupAddress={...data.returnAddress};
    data.acknowledged=data.acknowledged==='on';
    return data;
  }
  addPair(dl,label,value) {
    if(!value)return;
    const dt=document.createElement('dt'),dd=document.createElement('dd');
    dt.textContent=label;dd.textContent=value;dl.append(dt,dd);
  }
  review() {
    const p=this.payload(),dl=this.querySelector('[data-review]');dl.replaceChildren();
    for(const key of ['model','serial','repairType','orderNumber','purchaseDate','seller','category','description','errorCode','checks','accessories','mediaUrl','name','email','phone','company','companyCode','delivery','returnMethod','notes']) {
      let value=p[key];
      if(['category','repairType','delivery','returnMethod'].includes(key) && value)value=this.t(key==='category' && value==='other'?'other_fault':value);
      this.addPair(dl,this.t(key),value);
    }
    const format=a=>[a.name,a.street,[a.postal,a.city].join(' '),this.t(a.country==='other'?'other_country':a.country)].join('\n');
    if(p.returnMethod==='courier')this.addPair(dl,this.t('return_address'),format(p.returnAddress));
    if(p.delivery==='courier_request')this.addPair(dl,this.t('pickup_address'),format(p.pickupAddress));
    if(this.media.length)this.addPair(dl,this.t('upload_label'),this.media.map(f=>`${f.file.name} — ${this.t('upload_'+f.state)}`).join('\n'));
  }
  renderCase(target,data) {
    target.replaceChildren();const dl=document.createElement('dl');dl.className='kr-repair__review';
    this.addPair(dl,this.t('case_number'),data.caseNumber);
    this.addPair(dl,this.t('status'),this.t('status_'+data.status));
    this.addPair(dl,this.t('model'),data.model);this.addPair(dl,this.t('serial'),data.serial);
    this.addPair(dl,this.t('created'),new Intl.DateTimeFormat(document.documentElement.lang || 'lt',{dateStyle:'medium',timeStyle:'short',timeZone:'Europe/Vilnius'}).format(new Date(data.createdAt)));
    this.addPair(dl,this.t('customer_message'),data.customerMessage);target.append(dl);
  }
  async retryApi(path,options) {
    for(let attempt=0;attempt<3;attempt++){
      try {return await this.api(path,options);}
      catch(error) {
        if(attempt===2||!error.retryable&&!['TypeError','AbortError'].includes(error.name))throw error;
        // Reuse the signed request id and payload after uncertain responses.
        await new Promise(resolve=>setTimeout(resolve,500*(attempt+1)));
      }
    }
  }
  async saveCase(body) {
    // Keep uploads attached to their original session during every retry.
    const direct=this.session?.submit;
    if(direct&&direct.url!=='https://service.ner.lt/customer/submit')throw new Error('unavailable');
    if(direct){
      try{
        this.dataset.submissionTransport='direct';
        return await this.api('/cases',{method:'POST',body,direct});
      }catch(error){
        if(!['TypeError','AbortError'].includes(error.name)&&error.message!=='unavailable')throw error;
      }
    }
    this.dataset.submissionTransport='shopify_proxy';
    return this.retryApi('/cases',{method:'POST',body});
  }
  async submit() {
    if(this.busy || !this.ready)return;
    if(this.uploading||this.media.some(f=>f.state!=='done')){this.error('upload_wait');return;}
    // Enter in an earlier step advances instead of silently submitting incomplete data.
    if(this.step!==3){if(this.validStep())this.showStep(this.step+1);return;}
    if(!this.validStep())return;
    for(let i=0;i<3;i++) {this.step=i;if(!this.validStep(false)){this.showStep(i);this.validStep();return;}}
    this.step=3;this.busy=true;
    const button=this.querySelector('[data-submit]');button.disabled=true;button.textContent=this.t('submitting');
    try {
      const body=new URLSearchParams({repair_payload:JSON.stringify({...this.payload(),requestId:this.session.requestId,csrf:this.session.csrf})});
      const data=await this.saveCase(body);
      if(!/^KR-[A-F0-9]{20}$/.test(data.caseNumber || '') || !data.createdAt)throw new Error('unavailable');
      this.querySelector('[data-workspace]').hidden=true;
      this.querySelector('[data-success]').hidden=false;
      this.querySelector('[data-case-number]').textContent=data.caseNumber;
      this.renderCase(this.querySelector('[data-case-detail]'),data);
      this.querySelector('[data-lookup] [name=case]').value=data.caseNumber;
      this.querySelector('[data-success] h2').focus();
      this.session=null;
    } catch(error) {
      console.warn('Repair submission failed',error.name,error.message);this.querySelector('[data-error]').dataset.failure=error.name+':'+error.message;
      if(['session_expired','login_required','authentication'].includes(error.message)) {
        this.session=null;this.ready=false;this.querySelector('[data-retry]').hidden=false;
        this.querySelector('[data-service-status]').hidden=false;this.serviceMessage(error.message==='session_expired'?'session_expired':'login_required');
      }
      this.error(this.strings[error.message]?error.message:'unavailable');
    } finally {this.busy=false;button.disabled=!this.ready;button.textContent=this.t('submit');}
  }
  async lookup() {
    const form=this.querySelector('[data-lookup]'),target=this.querySelector('[data-lookup-result]');
    const caseInput=form.querySelector('[name="case"]');
    const number=caseInput.value.trim().toUpperCase();
    if(!/^KR-[A-F0-9]{20}$/.test(number)){target.textContent=this.t('invalid_value');caseInput.focus();return;}
    if(this.dataset.enabled!=='true'){target.textContent=this.t('not_enabled');return;}
    const button=form.querySelector('button'),print=this.querySelector('[data-lookup-print]');button.disabled=true;target.textContent=this.t('loading');if(print)print.hidden=true;
    try {const data=await this.retryApi('/cases?case='+encodeURIComponent(number));this.renderCase(target,data);target.dataset.caseNumber=data.caseNumber;if(print)print.hidden=false;}
    catch(error){target.textContent=this.t(this.strings[error.message]?error.message:'unavailable');}
    finally {button.disabled=false;}
  }
  async reset() {
    for(const item of this.media)if(item.preview)URL.revokeObjectURL(item.preview);this.media=[];this.renderMedia();this.mediaError(null);
    this.form.reset();this.syncFields();this.showStep(0,false);
    this.querySelector('[data-success]').hidden=true;this.querySelector('[data-case-detail]').replaceChildren();
    this.querySelector('[data-workspace]').hidden=false;await this.bootstrap();this.steps[0].querySelector('h2').focus();
  }
}
if(!customElements.get('kr-repair-registration'))customElements.define('kr-repair-registration',RepairRegistration);
